import React from 'react';
import IconImg from 'shared/icon-img';

export default function IconComponent(props) {
  try {
    const renderIcon = () => require(`./${props.icon}`).default;
    const { icon = 'icon', ...other } = props;
    const Icon = renderIcon();
    return <Icon {...other} />;
  } catch (e) {
    const { icon = 'icon', ...other } = props;
    return <IconImg {...other} src={icon} />;
  }
}
